"use strict";

import _ from "lodash";
import React from "react";
import connectToStores from "alt/utils/connectToStores";
import ConferenceActions from "../../actions/conference.actions";
import ConferenceStore from "../../stores/conference.store";
import ConferencesStore from "../../stores/conferences.store";
import WebinarActions from "../../actions/webinar.actions";
import WebinarsStore from "../../stores/webinars.store";

import Header from "../common/header";
import Listing from "../common/listing";
// import Event_Search from "../conferences/event_search";
import Featured_Event from "../common/featured_event";
import Upcoming_Event from "../common/upcoming_event";
import Recent_Event from "../common/recent_event";
import Analytics from "../common/analytics";
import Footer from "../common/footer";

@connectToStores
class Main extends React.Component {
  constructor(props) {
    super(props);

    /* get parent route as string */
    let currentRoute = this.props.routes[this.props.routes.length - 1];
    currentRoute = currentRoute.path;

    if (currentRoute == "/") {
      currentRoute = "conferences";
    }

    let feedLoadType = "conference";
    if (currentRoute == "webinars") {
      feedLoadType = "webinar";
    }

    this.state = {
      view: "",
      feedType: feedLoadType,
      date_order: "date:ASC",
      searchSubmitted: 0,
      renderCount: 3,
      renderType: currentRoute,
      searchKeyword: "",
      searchCity: "",
      searchYear: "",
      searchNotify: ""
    };

    this.onLoadData();
  }

  /* start: search form functions */

  handleChange = event => {
    let formVars = {};
    formVars[event.target.name] = event.target.value;
    this.setState(formVars);
  };

  handleSubmitClick = (event) => {
    event.preventDefault();
    const theKeyword = this._searchKeyword.value ? this._searchKeyword.value : null;
    const theCity = this._searchCity.value ? this._searchCity.value : null;
    const theYear = this._searchYear.value ? this._searchYear.value : null;

    if (theKeyword == null && theCity == null && theYear == null) {
      this.setState({
        searchNotify: 'Please select at least one search criteria to refine your search.'
      });
    } else {
      this.setState({
        searchSubmitted: 1,
        renderCount: 30,
        date_order: "date:DESC",
        searchKeyword: theKeyword,
        searchCity: theCity,
        searchYear: theYear,
        searchNotify: ""
      });
    }
  }

  handleReset = event => {
    event.preventDefault();
    document.getElementById("pi-events-searchform").reset();
    this.setState({
      date_order: "date:ASC",
      searchSubmitted: 0,
      renderCount: 3,
      searchKeyword: "",
      searchCity: "",
      searchYear: "",
      searchNotify: ""
    });
  };

  /* end: search form functions */

  static getStores(props) {
    return [ConferenceStore, ConferencesStore, WebinarsStore];
  }

  static getPropsFromStores(props) {
    return {
      conference: ConferenceStore.getState(),
      conferences: ConferencesStore.getState(),
      webinars: WebinarsStore.getState()
    };
  }

  onLoadData() {
    ConferenceActions.loadAll({
      type: "conference",
      fields:
        "name,status,year,search,locations,conference_id,conference_description,summary,sponsor_logo,conference_type,conference_url,registration,agenda_html,description,title,date,webinar_type,webinar_id,venue,eventtype,start,marketing_img,related_events,defaultYear,defaultCity,defaultSearch,time,link"
    });
    WebinarActions.loadAll({
      type: "webinar",
      fields:
        "name,status,year,search,locations,conference_id,conference_description,summary,sponsor_logo,conference_type,conference_url,registration,agenda_html,description,title,date,webinar_type,webinar_id,venue,eventtype,start,marketing_img,related_events,defaultYear,defaultCity,defaultSearch,time,link",
      date_order: this.state.date_order
    });
  }

  render() {
    let path = "/" + this.state.renderType;
      
    /* years for search form */
    let startYear = 2011;
    let thisYear = (new Date()).getFullYear();
    let minOffset = 0, maxOffset = (thisYear - startYear);
    let allYears = [];
    for(let x = 0; x <= maxOffset; x++) {
        allYears.push(thisYear - x)
    }
    const yearList = allYears.map((x) => { return (<option key={x}>{x}</option>) });
    
    let featured_conference = _(this.props.conferences.upcoming)
      .sortBy('next_date')
      .slice(0, 1)
      .map(conference => {
        return (
          <Featured_Event
            key={conference._id}
            event={conference}
            formatDate="dddd, MMM. D"
            locations={true}
            image={true}
            inverse={false}
          />
        );
      })
      .value();
  
    let upcoming_event = null;
    if (this.state.renderType == "conferences") {
      upcoming_event = _(this.props.conferences.upcoming)
        .sortBy('next_date')
        .slice(1, 15)
        .map((conference, index) => {
          return (
            <Upcoming_Event
              countIndex={index}
              key={conference._id}
              event={conference}
              locations={true}
              image={false}
              eventType="conference"
            />
          );
        })
        .value();
    } else if (this.state.renderType == "webinars") {
      upcoming_event = _(this.props.webinars.upcoming)
        .slice(0, 15)
        .map((webinar, index) => {
          return (
            <Upcoming_Event
              countIndex={index}
              key={webinar._id}
              event={webinar}
              locations={true}
              image={false}
              eventType="webinar"
            />
          );
        })
        .value();
    }
    
    let citySearch = this.state.searchCity ? this.state.searchCity : false;
    let textSearch = this.state.searchKeyword ? this.state.searchKeyword : false;
    let yearSearch = this.state.searchYear ? this.state.searchYear : false;
    
    let search_unfiltered = '';
    if (this.state.feedType == "conference") {
      search_unfiltered = this.props.conferences.all;
    } else {
      search_unfiltered = this.props.webinars.all;
    }
         
    let searched_filtered = _.filter(search_unfiltered, r => {
      
      let flag_text = false, flag_city = false, flag_year = false;
      if (textSearch) {
        flag_text = r.search_string.includes(textSearch);
        if (flag_text == false) {
          return null;
        }
      }
      if (citySearch) {
        _.filter(r.locations, cityItem => {
          flag_city = cityItem.city.includes(citySearch);
        })
        if (flag_city == false) {
          return null;
        }
      }
      if (yearSearch) {
        flag_year = r.year.includes(yearSearch);
        if (flag_year == false) {
          return null;
        }
      }
      return true;
    });

    let searched_event = _(searched_filtered)
      .slice(0, 500)
      .reverse()
      .map((conference,index) => {
        return (
          <Upcoming_Event
            countIndex={index}
            key={conference._id}
            event={conference}
            locations={true}
            image={false}
            eventType={this.state.feedType}
          />
        );
      })
      .value();

    let recent_event = null;
    if (this.state.renderType == "conferences") {
      recent_event = _(this.props.conferences.recent)
        .slice(0, 500)
        .reverse()
        .map((conference, index) => {
          return (
            <Recent_Event
              countIndex={index}
              title="Recent Conferences"
              key={conference._id}
              event={conference}
              charLimit={150}
              locations={false}
              image={false}
            />
          );
        })
        .value();
    } else if (this.state.renderType == "webinars") {
      recent_event = _(this.props.webinars.recent)
        .slice(0, 300)
        .reverse()
        .map((webinar, index) => {
          return (
            <Recent_Event
              countIndex={index}
              title="Recent Webinars"
              key={webinar._id}
              event={webinar}
              charLimit={150}
              locations={false}
              image={false}
              eventType="webinar"
            />
          );
        })
        .value();
    }

    let listing_output =
      this.state.searchSubmitted == 1 ? searched_event : upcoming_event;

    return (
      <div className="page-events">

        <Header
          pagetype={this.state.renderType}
          path={path}
          conference={this.props.conference}
          marketing={this.props.conference.marketing}
        />
        <main>
          <div className="wrap-one">
            <section className="secondary-header clearfix">
              <h1>Events <span className="hed-label">{this.state.renderType}</span></h1>
              <a href="mailto:npirrello@pionline.com?cc=kjackson@pionline.com&amp;subject=Conference%20Sponsorship%20Opportunities">
                Sponsorship Opportunities&nbsp;
                <i className="fa fa-angle-right" />
              </a>
            </section>
            <section id="featured-event">
              {featured_conference}
            </section>
            <section id="events" className="section-two">
              <div className="wrap-one clearfix">
                <nav id="event-nav" className="upcoming-event-tabs">
                  <ul className="clearfix">
                    <li
                      className={
                        this.state.renderType == "conferences"
                          ? "current"
                          : "latent"
                      }
                    >
                      <a href="/conferences">{this.state.searchSubmitted == 0 ? 'Upcoming Conferences' : 'Conferences'}</a>
                    </li>
                    <li
                      className={
                        this.state.renderType == "webinars"
                          ? "current"
                          : "latent"
                      }
                    >
                      <a href="/webinars">{this.state.searchSubmitted == 0 ? 'Upcoming Webinars' : 'Webinars' }</a>
                    </li>
                  </ul>
                </nav>
              </div>

              {/* start: search form */}

              <div className="wrap-two">
                <div id="search">
                  <form
                    className="pi-form clearfix"
                    id="pi-events-searchform"
                    onSubmit={this.handleSubmitClick}
                  >
                    <div className="input">
                      <input
                        type="text"
                        ref={input => (this._searchKeyword = input)}
                        name="searchKeyword"
                        id="keyword"
                        placeholder="Search by Keyword"
                      />
                    </div>

                    {this.state.feedType == "conference" ? (
                      <div className="input">
                        <select
                          name="searchCity"
                          id="city"
                          ref={select => (this._searchCity = select)}
                        >
                          <option value="">Select A City</option>
                          <option value="New York">New York</option>
                          <option value="Atlanta">Atlanta</option>
                          <option value="Chicago">Chicago</option>
                          <option value="Miami">Miami</option>
                          <option value="Dallas">Dallas</option>
                          <option value="Edinburgh">Edinburgh</option>
                          <option value="London">London</option>
                          <option value="Manchester">Manchester</option>
                          <option value="San Francisco">San Francisco</option>
                          <option value="Tokyo">Tokyo</option>
                          <option value="San Diego">San Diego</option>
                          <option value="Washington DC">Washington DC</option>
                          <option value="Toronto">Toronto</option>
                          <option value="Abuja">Abuja</option>
                          <option value="The Hague">The Hague</option>
                        </select>
                      </div>
                    ) : this._searchCity = ""}

                    <div className="input">
                      <select
                        name="searchYear"
                        id="year"
                        ref={select => (this._searchYear = select)}
                      >
                        <option value="">Select A Year</option>
                        {yearList}
                      </select>
                    </div>

                    <div id="formButtons" className="submit">
                      <input type="submit" value="Search" />
                      <div>
                        <a href="#" onClick={this.handleReset}>
                          reset
                        </a>
                      </div>
                    </div>
                  </form>
                  {this.state.searchNotify ? <p className="search-notify">{this.state.searchNotify}</p> : null}
                </div>
              </div>

              {/* end: search form */}

              <Listing
                elements={listing_output}
                limit={this.state.searchSubmitted == 1 ? null : this.state.renderCount}
                buttonText={"View More Upcoming " + this.state.renderType} 
              />
            </section>

            <section id="recent-events" className="wrap-one">
              <Listing
                elements={recent_event}
                limit={3}
                title={"Recent " + this.state.renderType}
                buttonText={"View More Recent " + this.state.renderType}
              />
            </section>
            <Analytics view={this.state.renderType} {...this.props} />
          </div>
        </main>
        <Footer
          conference={this.props.conference}
          path={path}
          view={this.state.renderType}
          {...this.props}
        />
      </div>
    );
  }
}

export default Main;
